import {channelOfSnapshots} from './sagas'
import {
  ResearchStateTab,
  ResearchStateTabs,
  ResearchStateQuery,
} from '$src/bootstrap/Store'
import {getMstStore} from '$src/bootstrap/rootSaga'
import {IStore} from '$src/bootstrap/Store'
import {fork, take, cancel} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import {getSnapshot, applySnapshot} from 'mobx-state-tree'
import callEndpoint from '$src/api/sagas/callEndpoint'
import queryComparableSales from '$src/api/endpoints/comparableSales/query'
import {keyBy} from 'lodash'

export default function* watchAndPerformQueries(hcid: string): Generator {
  const mstStore: IStore = yield getMstStore()
  const tabs = (mstStore.researchStates.byHousingCorporationId.get(hcid) as any)
    .tabs
  const theChannel = yield channelOfSnapshots(tabs)

  const currentStateHandlersByTabId: any = {}

  function* dd(snapshot: typeof ResearchStateTabs.SnapshotType): Generator {
    for (const tabId in snapshot.byId) {
      if (!currentStateHandlersByTabId[tabId]) {
        currentStateHandlersByTabId[tabId] = yield fork(
          watchTabAndPerformNecessaryQueries,
          hcid,
          tabId,
        )
      }
    }
  }

  const initialSnapshot: typeof ResearchStateTabs.SnapshotType = getSnapshot(
    tabs,
  )
  yield fork(dd, initialSnapshot)

  while (true) {
    const snapshot: typeof ResearchStateTabs.SnapshotType = yield take(
      theChannel,
    )
    yield fork(dd, snapshot)
  }
}

function* watchTabAndPerformNecessaryQueries(
  hcid: string,
  tabId: string,
): Generator {
  const mstStore: IStore = yield getMstStore()
  const tab: typeof ResearchStateTab.Type = (mstStore.researchStates.byHousingCorporationId.get(
    hcid,
  ) as any).tabs.byId.get(tabId)

  const theChannel = (yield channelOfSnapshots(tab.query)) as $IntentionalAny

  let lastTask: $IntentionalAny

  if (tab.foundItems.queried !== true) {
    lastTask = yield fork(performQuery, hcid, tabId)
  }

  while (true) {
    yield take(theChannel)
    if (mstStore.housingCorporations.byId.get(hcid)!.isFrozen()) {
      // console.error(
      //   `Housing corporation is frozen, yet researchState has changed. This should never happen. Investigate.`,
      // )
      continue
    }
    tab.setQueriedStatus(false)
    if (lastTask) {
      try {
        yield cancel(lastTask)
      } catch (e) {
        // console.log('e', e)
      }
      lastTask = null
    }

    lastTask = yield fork(performQuery, hcid, tabId)
  }
}

function* performQuery(hcid: string, tabId: string): Generator {
  yield delay(200)
  const mstStore: IStore = (yield getMstStore()) as $IntentionalAny
  const tab: typeof ResearchStateTab.Type = (mstStore.researchStates.byHousingCorporationId.get(
    hcid,
  ) as any).tabs.byId.get(tabId)

  const query: typeof ResearchStateQuery.SnapshotType = getSnapshot(tab.query)
  let result
  try {
    result = yield callEndpoint(queryComparableSales, query)
  } catch (e) {
    console.log('>> queryComparableSales error:')
    console.error(e)
  }

  const snapshot = {
    byId: keyBy(
      result.map(r => ({...r, disabled: true})),
      'id',
    ),
    list: result.map(s => s.id),
    queried: true,
    selectedIds: getSnapshot(tab.foundItems.selectedIds),
    selectedIdsRent: getSnapshot(tab.foundItems.selectedIdsRent),
    selectedIdsOldData: getSnapshot(tab.foundItems.selectedIdsOldData),
  }

  applySnapshot(tab.foundItems, snapshot)
}



// WEBPACK FOOTER //
// ./src/comparableSales/sagas/watchAndPerformQueries.tsx